'use client'

import { createContext, useEffect, useState, type PropsWithChildren } from 'react'
import { URL_DPV_BRIDGE } from '@/config/account'
import { AuthData } from '@/types/account'

export const AccountContext = createContext<AuthData | undefined>(undefined)

type AccountProviderProps = PropsWithChildren<unknown> & {
  webview: boolean
}

export const AccountProvider = ({ webview, children }: AccountProviderProps) => {
  const [authData, setAuthData] = useState<AuthData | undefined>(undefined)
  const ifrOrigin = new URL(URL_DPV_BRIDGE).origin

  useEffect(() => {
    if (!webview) {
      const authIframe = document.createElement('iframe')

      window.addEventListener('message', function (e) {
        if (e.origin !== ifrOrigin) return
        if (e.data && e.data.auth) {
          const data = e.data.auth

          let contextData: AuthData | undefined = undefined

          if (data.loggedIn) {
            contextData = {
              loggedIn: true,
              userInfo: {
                hasSubscription: data.abo && data.abo.name ? true : false,
                paidContent: data.paidContent,
                name: data.given_name ? data.given_name : null,
                surname: data.family_name ? data.family_name : null,
              },
              logout: () => {
                // eslint-disable-next-line @typescript-eslint/no-unused-expressions
                authIframe.contentWindow?.postMessage({ auth: { doLogout: true } }, ifrOrigin)
              },
            }
          } else {
            contextData = {
              loggedIn: false,
              liUrl: data.liUrl,
            }

            document.cookie = '_ntv_laurl=' + encodeURIComponent(document.location.href) + '; path=/; domain=n-tv.de'
          }
          setAuthData(contextData)
        }
      })

      authIframe.src = URL_DPV_BRIDGE + '?pa_origin=' + location.origin
      authIframe.style.width = '0'
      authIframe.style.height = '0'
      authIframe.style.border = '0'
      authIframe.style.position = 'absolute'
      authIframe.onload = () => {
        authIframe.contentWindow?.postMessage({ authRedirect: document.location.href }, ifrOrigin)
      }
      document.body.appendChild(authIframe)
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return <AccountContext.Provider value={authData}>{children}</AccountContext.Provider>
}
